/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyContact } from './EmergencyContact';
import {
    EmergencyContactFromJSON,
    EmergencyContactFromJSONTyped,
    EmergencyContactToJSON,
    EmergencyContactToJSONTyped,
} from './EmergencyContact';

/**
 * 
 * @export
 * @interface UpdateEmergencyContactResponse
 */
export interface UpdateEmergencyContactResponse {
    /**
     * 
     * @type {EmergencyContact}
     * @memberof UpdateEmergencyContactResponse
     */
    data: EmergencyContact;
}

/**
 * Check if a given object implements the UpdateEmergencyContactResponse interface.
 */
export function instanceOfUpdateEmergencyContactResponse(value: object): value is UpdateEmergencyContactResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEmergencyContactResponseFromJSON(json: any): UpdateEmergencyContactResponse {
    return UpdateEmergencyContactResponseFromJSONTyped(json, false);
}

export function UpdateEmergencyContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmergencyContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmergencyContactFromJSON(json['data']),
    };
}

  export function UpdateEmergencyContactResponseToJSON(json: any): UpdateEmergencyContactResponse {
      return UpdateEmergencyContactResponseToJSONTyped(json, false);
  }

  export function UpdateEmergencyContactResponseToJSONTyped(value?: UpdateEmergencyContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmergencyContactToJSON(value['data']),
    };
}

